import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Controller, useForm} from 'react-hook-form'
import {joiResolver} from '@hookform/resolvers/joi'
import {
  VmoButton,
  VmoForm,
  VmoFormField,
  VmoFormInput,
  VmoFormTextArea,
  VmoModal,
  VmoModalActions,
  VmoModalContent,
  VmoModalHeader,
  VmoTooltip,
} from 'vmo-library'

import {createKnowledgebase} from 'actions'
import {CREATE_KNOWLEDGEBASE} from 'actions/types'
import {createKnowledgebaseSchema} from 'validation/knowledge-base/settings.schema'
import {removeDoubleQuotes} from 'utils/helper'
import {AiOutlineInfoCircle} from 'react-icons/ai'
import {Input, TextArea} from 'components/common/Form'

const CreateKnowledgebase = ({open, toggle}) => {
  const {isLoadingData, type, successLabels = []} = useSelector(state => state.apiReducer)
  const dispatch = useDispatch()

  const {
    handleSubmit,
    formState: {errors},
    control,
  } = useForm({
    mode: 'onTouched',
    shouldFocusError: true,
    reValidateMode: 'onChange',
    defaultValues: {
      name: '',
      detail: '',
    },
    resolver: joiResolver(createKnowledgebaseSchema),
  })

  useEffect(() => {
    if (successLabels.includes(CREATE_KNOWLEDGEBASE)) {
      toggle(false)
    }
  }, [successLabels, toggle])

  const onCreateKb = data => {
    dispatch(createKnowledgebase(data))
  }

  return (
    <VmoModal open={open} centered={false} size="tiny" closeIcon onClose={() => toggle(false)}>
      <VmoModalHeader>Create Knowledgebase</VmoModalHeader>
      <VmoModalContent>
        <VmoForm className="errorLabel">
          <Input
            name="name"
            control={control}
            required
            label="Name"
            maxLength={20}
            tooltipProps={{
              content: 'Give a name to your knowledge base',
            }}
          />
          <TextArea
            name="detail"
            control={control}
            label="Description"
            tooltipProps={{
              content: 'Specify a brief description about the knowledge base',
            }}
            maxLength={150}
          />
        </VmoForm>
      </VmoModalContent>
      <VmoModalActions>
        <VmoButton basic onClick={() => toggle(false)}>
          Cancel
        </VmoButton>
        <VmoButton
          loading={isLoadingData && type.includes(CREATE_KNOWLEDGEBASE)}
          disabled={isLoadingData && type.includes(CREATE_KNOWLEDGEBASE)}
          primary
          onClick={handleSubmit(onCreateKb)}
        >
          Create
        </VmoButton>
      </VmoModalActions>
    </VmoModal>
  )
}

export default CreateKnowledgebase
